import { render, staticRenderFns } from "./ItemDisplay.vue?vue&type=template&id=2ec595c4&"
import script from "./ItemDisplay.vue?vue&type=script&lang=js&"
export * from "./ItemDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports